if (!window.Eurus.loadedScript.has('sticky-atc.js')) {
  window.Eurus.loadedScript.add('sticky-atc.js');

  // requestAnimationFrame is absent in some environments this script still
  // needs to run in (older in-app browsers, bots/crawlers evaluating the
  // page's JS); fall back to a timer so init never silently throws.
  var raf = typeof requestAnimationFrame === 'function'
    ? requestAnimationFrame.bind(window)
    : function (fn) { return setTimeout(fn, 16); };

  raf(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xStickyATC', (sectionId, is_combined, showAssociatedOnly) => ({
        openDetailOnMobile: false,
        currentAvailableOptions: [],
        options: [],
        init() {
          if (showAssociatedOnly) {
            document.addEventListener(`eurus:media-gallery-ready:${sectionId}`, () => {
              this.renderMedia();
            }, { once: true });
          }
          document.addEventListener(`eurus:product-page-variant-select:updated:${sectionId}`, (e) => {
            this.renderVariant(e.detail.html);
            this.renderProductPrice(e.detail.html);
            this.renderMedia(e.detail.html);
          });
        },
        renderProductPrice(html) {
          const destinations = Array.from(document.getElementsByClassName(`price-sticky-${sectionId}`));
          destinations.forEach((destination) => {
            const source = html.getElementById('price-sticky-' + sectionId);
            if (source && destination) destination.innerHTML = source.innerHTML;
          })
        },
        renderMedia(html) {
          if (showAssociatedOnly) {
            this.$nextTick(() => {
              const destination = document.getElementById('product-image-sticky-' + sectionId)?.querySelector('img');
              const source = document.querySelector('.product-media-container')?.querySelector('.media_active img')?.getAttribute('src');

              if (source && destination) destination.setAttribute('src', source);
            })
          } else {
            const destination = document.getElementById('product-image-sticky-' + sectionId);
            const source = html.getElementById('product-image-sticky-' + sectionId);
    
            if (source && destination) destination.innerHTML = source.innerHTML;
          }
        },
        renderVariant(html) {
          const destination = document.getElementById('variant-update-sticky-' + sectionId);
          const source = html.getElementById('variant-update-sticky-' + sectionId);
  
          if (source && destination) destination.innerHTML = source.innerHTML;
        },
        changeOptionSticky(event) {
          Array.from(event.target.options).forEach((option) => {
            option.removeAttribute('selected');
            if (option.selected) option.setAttribute('selected', '');
          });
          const input = event.target.selectedOptions[0];
          const targetUrl = input.dataset.productUrl;
          const variantEl = document.getElementById('variant-update-sticky-' + sectionId);
          document.dispatchEvent(new CustomEvent(`eurus:product-page-variant-select-sticky:updated:${sectionId}`, {
            detail: {
              targetUrl: targetUrl,
              variantElSticky: variantEl
            }
          }));
        }
      }))
    })
  })

  // The loyalty widget (Posloy, shadow DOM) and Tidio chat both float a
  // launcher button pinned to the bottom of the viewport on mobile, directly
  // under where the sticky Add to Cart bar appears once it's visible -
  // covering half of each button. Neither is theme markup (both are app
  // embeds), and Posloy's launcher lives inside an open shadow root, which a
  // stylesheet cannot select into - so this nudges both up by the bar's own
  // height via inline transforms instead of a CSS override.
  //
  // Leading semicolon is load-bearing: the block above ends in `})` with no
  // terminator, so without it ASI folds this IIFE's `(function(){...})()`
  // into that statement as a call on its return value - which is exactly
  // what threw "raf(...)/requestAnimationFrame(...) is not a function".
  ;(function () {
    var SHADOW_WIDGETS = [
      { hostId: 'posloy-shadow-host', selectors: ['#posloy-reopen-btn', '#posloy-rewards-block'] }
    ];
    var SCROLL_TOP_OFFSET_PX = 13;

    // Tidio's proactive greeting bubble (auto-shown a few seconds after load,
    // independent of the chat actually being opened) already overlaps
    // .scroll_top's resting position on desktop even with the ATC bar
    // hidden - the bar just happens to be what puts scroll_top on screen at
    // the same moment a buyer notices it. Measured live every tick instead
    // of hardcoding the bubble's height, since Tidio can resize or reword it
    // at any time.
    var CHAT_CLEARANCE_GAP_PX = 10;
    var lastSignature = '';
    var ticking = false;

    function tidioTopEdge() {
      var chat = document.getElementById('tidio-chat');
      if (!chat || !chat.shadowRoot) return Infinity;
      var nodes = chat.shadowRoot.querySelectorAll('*');
      var minTop = Infinity;
      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        var r = el.getBoundingClientRect();
        if (r.width <= 0 || r.height <= 0) continue;
        // #tidio-chat-root is a `pointer-events:none` layout shell that
        // reserves space top-to-bottom (~372x824) whether or not anything is
        // actually showing - a plain size filter can't tell it apart from a
        // real card. Real chrome (the launcher, a greeting bubble's input,
        // an open conversation) is always pointer-events:auto; that shell
        // and its purely decorative children never are.
        if (getComputedStyle(el).pointerEvents === 'none') continue;
        if (r.top < minTop) minTop = r.top;
      }
      return minTop;
    }

    function naturalBottom(el) {
      var prev = el.style.transform;
      el.style.transform = '';
      var bottom = el.getBoundingClientRect().bottom;
      el.style.transform = prev;
      return bottom;
    }

    // Same overlap, same fix, on any viewport: the bar sits fixed to the
    // bottom on desktop too (flush edge-to-edge for the full-width display
    // type; raised on md: for the popup type, which just means this nudges
    // the widgets a bit further than strictly necessary there - harmless).
    function visibleStickyAtcHeight() {
      // offsetParent is always null for a position:fixed element, so
      // visibility has to be read off computed display instead.
      var bars = document.querySelectorAll('.sticky_add_to_cart');
      for (var i = 0; i < bars.length; i++) {
        if (getComputedStyle(bars[i]).display !== 'none') return bars[i].getBoundingClientRect().height;
      }
      return 0;
    }

    function applyOffset() {
      ensureTidioShadowObserver();
      var height = visibleStickyAtcHeight();
      var transform = height ? 'translateY(-' + height + 'px)' : '';

      var chat = document.getElementById('tidio-chat');
      if (chat) chat.style.transform = transform;

      SHADOW_WIDGETS.forEach(function (widget) {
        var root = document.getElementById(widget.hostId);
        root = root && root.shadowRoot;
        if (!root) return;
        widget.selectors.forEach(function (selector) {
          var el = root.querySelector(selector);
          if (!el) return;
          // Plain assignment is silently beaten by a `transform: ... !important`
          // rule Posloy's own shadow styles apply at desktop widths (mobile
          // has no such rule, which is why a plain assignment happened to work
          // there) - match its own priority instead of guessing which of its
          // rules set it.
          if (transform) el.style.setProperty('transform', transform, 'important');
          else el.style.removeProperty('transform');
        });
      });

      // Measured only now that chat's own transform for THIS tick is already
      // applied above - reading it any earlier would see last tick's
      // position (e.g. still bar-nudged a moment after the bar itself just
      // hid), overstate how far .scroll_top needs to move, and - since
      // nothing further may mutate to trigger a re-check - bake that stale,
      // too-large gap in permanently.
      var chatTop = tidioTopEdge();
      var signature = height + '|' + (chatTop === Infinity ? 'x' : Math.round(chatTop));
      if (signature === lastSignature) return;
      lastSignature = signature;

      // .scroll_top already carries its own Tailwind transform (the
      // -rotate-90 arrow icon, and -translate-x-1/2 when centered) composed
      // from --tw-* custom properties. Overwriting its inline transform
      // outright would drop those; reading the same custom properties back
      // into our own inline transform stacks our nudge on top instead,
      // whatever combination of rotate/translate classes is in play.
      //
      // The Y slot is set directly (not `calc(var(--tw-translate-y) - Npx)`
      // added on top of it): Tailwind's own default for that variable is the
      // unitless `0`, and `calc(0 - 13px)` mixes a <number> with a <length>,
      // which is invalid - it silently drops the ENTIRE transform (rotation
      // included) rather than just failing to add the offset. .scroll_top
      // never has a translate-Y utility of its own, so there's nothing to
      // preserve there anyway.
      //
      // Mobile keeps the flat 13px as-is (already confirmed correct there -
      // .scroll_top's mobile `bottom` sits far enough above the chat launcher
      // that a small fixed nudge is all it ever needed). Desktop's `bottom`
      // is much closer to the chat launcher's, so pushing chat up by the FULL
      // bar height while only nudging .scroll_top by 13px let chat overtake
      // it and land on top of it - matching `height` instead moves both by
      // the same amount, preserving their original gap instead of consuming
      // it. Scoped to desktop only so mobile's already-approved 13px doesn't
      // change.
      // Zero, not 13, when the bar itself is hidden (e.g. the true page
      // footer, past where the bar shows at all) - otherwise .scroll_top
      // sits at a DIFFERENT gap from the chat launcher there than it does
      // with the bar visible, since only .scroll_top would be getting a
      // floor nudge while the launcher stays at its natural spot.
      var isDesktop = window.matchMedia('(min-width: 768px)').matches;
      var scrollTopOffset = height ? (isDesktop ? Math.max(SCROLL_TOP_OFFSET_PX, height) : SCROLL_TOP_OFFSET_PX) : 0;
      var scrollTopBtn = document.querySelector('.scroll_top');
      if (scrollTopBtn) {
        // Whatever the bar needs isn't necessarily enough to clear Tidio's
        // own current footprint (launcher alone, or a taller greeting
        // bubble) - take whichever requirement is bigger.
        if (chatTop !== Infinity) {
          var neededForChat = naturalBottom(scrollTopBtn) - chatTop + CHAT_CLEARANCE_GAP_PX;
          if (neededForChat > scrollTopOffset) scrollTopOffset = neededForChat;
        }
        scrollTopBtn.style.transform = scrollTopOffset > 0
          ? 'translate(var(--tw-translate-x), -' + scrollTopOffset + 'px) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))'
          : '';
      }
    }

    function onViewportChange() {
      if (ticking) return;
      ticking = true;
      raf(function () {
        applyOffset();
        ticking = false;
      });
    }

    // The bar's own x-show toggles its inline display (and x-transition
    // toggles its classes) exactly when it should be nudging the widgets -
    // watching that directly is cheaper and more precise than recomputing on
    // every scroll frame.
    document.querySelectorAll('.sticky_add_to_cart').forEach(function (bar) {
      new MutationObserver(onViewportChange).observe(bar, { attributes: true, attributeFilter: ['style', 'class'] });
    });
    window.addEventListener('resize', onViewportChange);

    // Both widgets are injected asynchronously by their own app-embed
    // scripts, so a first pass can miss them; keep watching until both have
    // shown up (or give up after 20s so this doesn't run indefinitely on a
    // page where one of them is disabled).
    var widgetsReady = false;
    var observedShadowRoot = null;
    function ensureTidioShadowObserver() {
      var chat = document.getElementById('tidio-chat');
      var root = chat && chat.shadowRoot;
      // Compared by reference, not a once-only flag: Tidio's shadow root may
      // not exist yet the first few times this runs (its host div and its
      // shadow root aren't guaranteed to appear in the same tick), and a
      // one-shot "attached" flag set on a losing race never gets a retry, so
      // it silently observes nothing forever. Re-checking identity every
      // call is cheap and self-heals whenever the real root shows up.
      if (!root || root === observedShadowRoot) return;
      observedShadowRoot = root;
      // Shadow-root mutations don't bubble to an observer on document.body,
      // so the greeting bubble mounting/unmounting on Tidio's own timer -
      // unrelated to the ATC bar or a resize - needs its own observer here,
      // or applyOffset() would never re-run when it appears.
      new MutationObserver(onViewportChange).observe(root, {
        childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class']
      });
    }
    var bodyObserver = new MutationObserver(function () {
      applyOffset();
      if (document.getElementById('tidio-chat') && document.getElementById('posloy-shadow-host')) {
        widgetsReady = true;
        bodyObserver.disconnect();
      }
    });
    bodyObserver.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () {
      if (!widgetsReady) bodyObserver.disconnect();
    }, 20000);

    applyOffset();
  })();
}